/* Crochet Coasters theme JS — no dependencies */
(function () {
  'use strict';

  var moneyFormat = window.themeMoneyFormat || '£{{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  /* ----- cart count ----- */
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); })
      .catch(function () {});
  }

  /* ----- toast ----- */
  var toastTimer;
  function showToast(text) {
    var toast = document.getElementById('CartToast');
    if (!toast) return;
    toast.querySelector('.toast__text').textContent = text;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 3500);
  }

  /* ----- quantity pickers (event delegation, works in buy box + cart) ----- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty-picker');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = btn.getAttribute('data-qty-change') === 'up' ? 1 : -1;
    var next = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----- bundle-builder buy box ----- */
  function initBuyBox(box) {
    var dataEl = box.querySelector('[data-variant-data]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var hasProduct = box.getAttribute('data-has-product') === 'true';
    var unitPrice = parseInt(box.getAttribute('data-unit-price'), 10) || 1499;
    var bundleQty = parseInt(box.getAttribute('data-bundle-qty'), 10) || 3;
    var bundlePrice = parseInt(box.getAttribute('data-bundle-price'), 10) || 2999;

    var image = box.querySelector('[data-buy-box-image]');
    var priceEl = box.querySelector('[data-price]');
    var compareEl = box.querySelector('[data-compare-price]');
    var saveBadge = box.querySelector('[data-save-badge]');
    var atcBtn = box.querySelector('[data-atc-button]');
    var atcLabel = atcBtn && atcBtn.querySelector('[data-atc-label]');
    var slotsEl = box.querySelector('[data-bundle-slots]');
    var countLabel = box.querySelector('[data-bundle-count-label]');
    var savingsEl = box.querySelector('[data-bundle-savings]');
    var hintEl = box.querySelector('[data-bundle-hint]');
    var stickyBar = document.querySelector('[data-sticky-atc="' + box.getAttribute('data-buy-box') + '"]');

    var bundle = []; // ordered list of selected variant objects (taps persist here)

    function findVariant(styleValue) {
      return variants.find(function (v) { return v.option === styleValue; });
    }

    function total() {
      var n = bundle.length;
      var groups = Math.floor(n / bundleQty);
      var rest = n % bundleQty;
      return groups * bundlePrice + rest * unitPrice;
    }

    function savings() {
      return bundle.length * unitPrice - total();
    }

    function setImage(variant) {
      if (!image || !variant || !variant.image || image.getAttribute('src') === variant.image) return;
      image.classList.add('is-swapping');
      var next = new Image();
      next.onload = function () {
        image.src = variant.image;
        image.alt = variant.image_alt || variant.option;
        image.classList.remove('is-swapping');
      };
      next.src = variant.image;
    }

    function render() {
      var n = bundle.length;

      // slot tray: show at least one bundle's worth of slots, growing as needed
      if (slotsEl) {
        slotsEl.innerHTML = '';
        var slotCount = Math.max(bundleQty, n);
        for (var i = 0; i < slotCount; i++) {
          if (i < n) {
            var filled = document.createElement('button');
            filled.type = 'button';
            filled.className = 'bundle-slot bundle-slot--filled';
            filled.setAttribute('data-slot-remove', i);
            filled.setAttribute('aria-label', 'Remove ' + bundle[i].option + ' from bundle');
            var img = document.createElement('img');
            img.src = bundle[i].thumb || bundle[i].image;
            img.alt = '';
            img.width = 120;
            img.height = 120;
            filled.appendChild(img);
            slotsEl.appendChild(filled);
          } else {
            var empty = document.createElement('span');
            empty.className = 'bundle-slot bundle-slot--empty';
            slotsEl.appendChild(empty);
          }
        }
      }

      // per-critter count badges + selected styling
      box.querySelectorAll('[data-style-add]').forEach(function (btn) {
        var style = btn.getAttribute('data-style-add');
        var count = bundle.filter(function (v) { return v.option === style; }).length;
        var badge = btn.querySelector('.style-swatch__count');
        if (badge) {
          badge.textContent = count > 1 ? '×' + count : count;
          badge.setAttribute('data-count', count);
        }
        btn.classList.toggle('is-in-bundle', count > 0);
      });

      // labels & pricing
      if (countLabel) {
        if (n < bundleQty) countLabel.textContent = 'Your bundle · ' + n + ' of ' + bundleQty;
        else if (n === bundleQty) countLabel.textContent = 'Bundle complete! · ' + bundleQty + ' of ' + bundleQty;
        else countLabel.textContent = 'Your bundle · ' + n + ' critters';
      }
      if (savingsEl) {
        savingsEl.hidden = savings() <= 0;
        savingsEl.textContent = 'Saving ' + formatMoney(savings()) + ' 🎉';
      }
      if (hintEl) {
        if (n === 0) hintEl.textContent = 'Tap a critter above to add it — tap a slot to take it out.';
        else if (n < bundleQty) hintEl.textContent = 'Add ' + (bundleQty - n) + ' more to unlock the ' + formatMoney(bundlePrice) + ' bundle.';
        else if (n % bundleQty === 0) hintEl.textContent = 'Bundle deal unlocked — keep going or add to basket!';
        else hintEl.textContent = 'Add ' + (bundleQty - (n % bundleQty)) + ' more to unlock another bundle.';
      }

      if (priceEl) priceEl.textContent = formatMoney(n === 0 ? unitPrice : total());
      if (compareEl) {
        var s = savings();
        compareEl.hidden = s <= 0;
        if (s > 0) compareEl.textContent = formatMoney(n * unitPrice);
      }
      if (saveBadge) saveBadge.textContent = n === 0 ? 'each' : (savings() > 0 ? 'Bundle deal' : 'Handmade');

      if (atcBtn) {
        if (!hasProduct) {
          atcBtn.disabled = true;
          if (atcLabel) atcLabel.textContent = 'Coming soon';
        } else {
          atcBtn.disabled = n === 0;
          if (atcLabel) {
            atcLabel.textContent = n === 0
              ? 'Pick your critters'
              : 'Add ' + n + (n === 1 ? ' coaster' : ' coasters') + ' — ' + formatMoney(total());
          }
        }
      }

      if (stickyBar) {
        var thumb = stickyBar.querySelector('[data-sticky-thumb]');
        var styleEl = stickyBar.querySelector('[data-sticky-style]');
        var priceBarEl = stickyBar.querySelector('[data-sticky-price]');
        var last = bundle[n - 1];
        if (thumb && last) thumb.src = last.thumb || last.image;
        if (styleEl) styleEl.textContent = n === 0 ? 'Build your bundle' : (n === 1 ? last.option : n + ' critters picked');
        if (priceBarEl) priceBarEl.textContent = n === 0 ? formatMoney(unitPrice) + ' each' : formatMoney(total());
        var stickyBtn = stickyBar.querySelector('[data-sticky-add]');
        if (stickyBtn) stickyBtn.disabled = !hasProduct || n === 0;
      }
    }

    box.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-style-add]');
      if (addBtn && !addBtn.disabled) {
        var variant = findVariant(addBtn.getAttribute('data-style-add'));
        if (variant) {
          bundle.push(variant);
          setImage(variant);
          render();
        }
        return;
      }
      var slotBtn = e.target.closest('[data-slot-remove]');
      if (slotBtn) {
        bundle.splice(parseInt(slotBtn.getAttribute('data-slot-remove'), 10), 1);
        var last = bundle[bundle.length - 1];
        if (last) setImage(last);
        render();
      }
    });

    function addToCart() {
      if (!hasProduct || bundle.length === 0) return;

      // collapse the tray into {variant id: quantity}
      var counts = {};
      bundle.forEach(function (v) {
        if (v.id) counts[v.id] = (counts[v.id] || 0) + 1;
      });
      var items = Object.keys(counts).map(function (id) {
        return { id: Number(id), quantity: counts[id] };
      });
      if (!items.length) return;

      var n = bundle.length;
      if (atcBtn) atcBtn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (data) { throw data; });
          return r.json();
        })
        .then(function () {
          refreshCartCount();
          showToast(n === 1 ? bundle[0].option + ' coaster added to basket' : n + ' coasters added to basket');
          bundle = [];
          render();
        })
        .catch(function (err) {
          showToast((err && err.description) || 'Could not add to basket');
        })
        .finally(function () {
          if (atcBtn) atcBtn.classList.remove('is-loading');
        });
    }

    if (atcBtn) atcBtn.addEventListener('click', addToCart);

    if (stickyBar) {
      var stickyAdd = stickyBar.querySelector('[data-sticky-add]');
      if (stickyAdd) stickyAdd.addEventListener('click', addToCart);

      if ('IntersectionObserver' in window && atcBtn) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        }, { threshold: 0 });
        io.observe(atcBtn);
      }
    }

    render();
  }

  /* ----- cart page: quantity changes ----- */
  function initCartPage() {
    document.querySelectorAll('[data-cart-line-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        var line = input.getAttribute('data-cart-line-qty');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: parseInt(input.value, 10) || 0 })
        })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.reload(); })
          .catch(function () { window.location.reload(); });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-buy-box]').forEach(initBuyBox);
    initCartPage();
    refreshCartCount();
  });
})();
